// extracted by mini-css-extract-plugin
export var animating = "_47-3";
export var background = "_47-6";
export var constrainHeight = "_47-2";
export var dark = "_47-4";
export var dropdown = "_47-1";
export var leave = "_47-5";
export var option = "_47-7";
export var root = "_47-0";